// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"153729e5","300":"76c85ead","372":"323e709a","592":"60faefcc"}[chunkId] + ".chunk.js";
};